module.exports = __webpack_public_path__ + "static/media/social-instagram.231ef354.svg";